<template>
  <el-card shadow="never">
    <div slot="header">
      <span>Carrier</span>
    </div>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-card
              :gutter="10"
              shadow="never"
            >
              <div slot="header">
                <span>Integration</span>
              </div>
              <p><strong>Quote Via Carrier API:</strong> {{ availableFormatter(carrier.quote_template) }}</p>
              <p><strong>Creates Consignment Externally:</strong> {{ yesNoFormatter(carrier.creates_consignment_externally) }}</p>
              <p><strong>Sends EDI:</strong> {{ yesNoFormatter(carrier.transfer_type) }}</p>
              <p><strong>Third Party Pays:</strong> {{ availableFormatter(carrier.third_party_pays) }}</p>
              <p><strong>Prints Label:</strong> {{ yesNoFormatter(carrier.print_label) }}</p>
              <p><strong>Prints Connote:</strong> {{ yesNoFormatter(carrier.print_connote) }}</p>
              <p><strong>Custom Validation Rules:</strong> {{ yesNoFormatter(carrier.validation_template) }}</p>
            </el-card>
          </el-col>
          <el-col
            :span="12"
            :gutter="10"
          >
            <el-card
              :gutter="10"
              shadow="never"
            >
              <div slot="header">
                <span>Tracking</span>
              </div>
              <p><strong>Tracking Enabled:</strong> {{ yesNoFormatter(carrier.tracking_transformer_template) }}</p>
              <p><strong>Item Level Tracking:</strong> {{ yesNoFormatter(carrier.supports_item_tracking) }}</p>
              <p><strong>OpenFreight Generated POD:</strong> {{ yesNoFormatter(carrier.carrier_pod_type) }}</p>
              <p><strong>POD Treated as Delivery Scan:</strong> {{ yesNoFormatter(carrier.carrier_tracking_pod_is_delivery_scan) }}</p>
            </el-card>
          </el-col>
        </el-row>
        <br>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-card
              :gutter="10"
              shadow="never"
            >
              <div slot="header">
                <span>Pickups</span>
              </div>
              <p><strong>Sends Pickup:</strong> {{ yesNoFormatter(carrier.pickup_type) }}</p>
              <p><strong>Email or API:</strong> {{ carrier.pickup_type === false ? '-' : carrier.pickup_template === 'Email' ? 'Email' : 'API' }}</p>
              <p><strong>Cut Off Time:</strong> {{ getCutOff(carrier.pickup_cutoff) }}</p>
              <p><strong>Hold On Creation:</strong> {{ yesNoFormatter(carrier.pickup_hold_on_creation) }}</p>
              <p><strong>Hold If Same Day:</strong> {{ yesNoFormatter(carrier.pickup_hold_if_same_day) }}</p>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card
              :gutter="10"
              shadow="never"
            >
              <div slot="header">
                <span>Features</span>
              </div>
              <p><strong>Residential:</strong> {{ yesNoFormatter(carrier.supports_residential) }}</p>
              <p><strong>International:</strong> {{ yesNoFormatter(carrier.supports_international) }}</p>
              <p><strong>GPS Tracking:</strong> {{ yesNoFormatter(carrier.carrier_supports_gps_tracking) }}</p>
              <p><strong>Run Sheets:</strong> {{ yesNoFormatter(carrier.carrier_supports_run_sheets) }}</p>
              <p><strong>Configuration Notes:</strong> {{ carrier.configuration_notes ? carrier.configuration_notes : '-' }}</p>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-card
          :gutter="10"
          shadow="never"
        >
          <div slot="header">
            <span>Services</span>
            <el-button
              type="text"
              @click.native="exportCsv"
            >
              Export CSV
            </el-button>
          </div>
          <el-table
            :data="visibleServices"
            stripe
            size="mini"
          >
            <el-table-column
              prop="name"
              label="Name"
            />
            <el-table-column
              label="TIG Shipping Code"
              prop="chainit"
            />
            <el-table-column
              label="Carrier Service Code"
              prop="code"
            />
          </el-table>
          <el-pagination
            class="text-center pt-3"
            layout="prev, pager, next"
            :total="carrier.carrier_services.length"
            :page-size="10"
            @current-change="handlePageChange"
          />
        </el-card>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
export default {
  props: {
    carrier: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      visibleServices: []
    }
  },
  created () {
    // Initialize visibleServices with the carrier's services
    this.visibleServices = this.carrier.carrier_services.slice(0, 10) || []
  },
  methods: {
    availableFormatter (value) {
      return value ? 'Available' : 'Not Available'
    },
    yesNoFormatter (value) {
      return value ? 'Yes' : 'No'
    },
    getCutOff (value) {
      return value ? this.$moment().set('hour', value).set('minute', '00').format('HH:mm') : '-'
    },
    handlePageChange (page) {
      // Calculate the start and end indices for slicing the services array
      const start = (page - 1) * 10
      const end = start + 10
      // Update visibleServices based on the current page
      this.visibleServices = this.carrier.carrier_services.slice(start, end)
    },
    exportCsv () {
      const csv = this.$papa.unparse(this.carrier.carrier_services)

      let blob = new Blob([csv], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${this.$inflected.constantify(this.carrier.name)}_SERVICES.csv`
      link.click()
    }
  }
}
</script>

<style>

</style>
